import Vue from "vue";
import "normalize.css/normalize.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/base.scss";
import "@/styles/index.scss";
import App from "./App";
import store from "./store";
// store.dispatch('operator/setOpeInfo')
import router from "./router";
import AmapVue from "@amap/amap-vue";
import htmlToPdf from "@/utils/htmlToPdf"
import "@/icons";
import "./icons/index";
import "@/permission";
// 百度富文本编译器
import VueEeditorWrap from "vue-ueditor-wrap";
Vue.component("vue-ueditor-wrap", VueEeditorWrap);
// 分页
import gyPagination from "@/components/pagination";
Vue.component("gy-pagination", gyPagination);
import directive from "./utils/directives";
Vue.use(directive);
import searchHide from "@/components/searchHide";
Vue.component("search-hide", searchHide);
// 日期转换器
import { parseTime, copy, getUrlName, noAuthorityId } from "@/utils";
Vue.prototype.$parseTime = parseTime;
Vue.prototype.$copy = copy;
Vue.prototype.$getUrlName = getUrlName;
Vue.prototype.$noAuthorityId = noAuthorityId;

Vue.use(htmlToPdf);
Vue.use(ElementUI);
/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);
// 上传图片接口
Vue.prototype.uploadImgApi =
  process.env.VUE_APP_MEETYOU_EN_API + "/api/enterprise/upload/add";

// AMap-vue 地图插件
AmapVue.config.version = "2.0"; // 默认2.0，这里可以不修改
AmapVue.config.key = "009cdb35d25642e29270dcc44b94a947";
AmapVue.config.plugins = [
  "AMap.ToolBar",
  "AMap.MoveAnimation",
  // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
];
Vue.use(AmapVue);

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

// 单点权限检测
Vue.prototype.authorityDetection = function (id) {
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (userInfo && userInfo.permissions && userInfo.permissions.length > 0) {
    let authority = userInfo.permissions.findIndex((item) => {
      return item * 1 == id * 1;
    });
    return authority == -1 ? false : true;
  } else {
    return true;
  }
};

// 联级选择数据处理
Vue.prototype.$levelDataHandle = function (dataList, data, key, category) {
  let dataCategory = [];
  for (let [index2, item2] of data.entries()) {
    dataCategory.push({
      value: item2.id,
      label: item2.name,
      isChildren: item2.isChildren,
      pid: item2.pid * 1,
      children: [],
      leaf: item2.leaf ? item2.leaf : !item2.isChildren,
    });
  }
  if (key == 0) {
    dataList = dataCategory;
  } else if (key == 1) {
    dataList.forEach((item, index) => {
      if (item.value == category[0]) {
        dataList[index].children = dataCategory;
      }
    });
  } else if (key == 2) {
    dataList.forEach((item, index) => {
      if (item.value == category[0]) {
        dataList[index].children.forEach((item1, index1) => {
          if (item1.value == category[1]) {
            dataList[index].children[index1].children = dataCategory;
          }
        });
      }
    });
  } else if (key == 3) {
    dataList.forEach((item, index) => {
      if (item.value == category[0]) {
        dataList[index].children.forEach((item1, index1) => {
          if (item1.value == category[1]) {
            dataList[index].children[index1].children.forEach(
              (item2, index2) => {
                dataList[index].children[index1].children[index2].children =
                  dataCategory;
              }
            );
          }
        });
      }
    });
  }
  return dataList;
};

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
